import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const KEYPER_ASSETS_URL = `${API_URL}/keyper/assets`;

export type KeyperAssetPayload = {
  name: string;
  description?: string;
  assetType?: string;
  assetRegisteredType?: string;
  attributeValue1?: string;
  attributeValue2?: string;
  attributeValue3?: string;
  attributeValue4?: string;
  attributeValue5?: string;
  attributeValue6?: string;
  attributeValue7?: string;
  lotLocationId?: number;
  parkingSpaceId?: number;
  processStepId?: number;
  shieldedAsset?: boolean;
  totalMileage?: number;
  monthlyMileage?: number;
  entrataPropertyUnitId?: string;
  parentAssetId?: number | null;
  lotLocationGroup?: string;
};

export const getKeyperAssets = createAsyncThunk(
  "keyperAssets/getKeyperAssets",
  async (
    params: { page: number; pageSize: number; search?: string; sort?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.get(KEYPER_ASSETS_URL, { params });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Failed to fetch Keyper assets"
      );
    }
  }
);

export const createKeyperAsset = createAsyncThunk(
  "keyperAssets/createKeyperAsset",
  async (payload: KeyperAssetPayload, { rejectWithValue }) => {
    try {
      const response = await axios.post(KEYPER_ASSETS_URL, payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Failed to create asset"
      );
    }
  }
);

export const updateKeyperAsset = createAsyncThunk(
  "keyperAssets/updateKeyperAsset",
  async (
    { id, payload }: { id: number; payload: KeyperAssetPayload },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.put(`${KEYPER_ASSETS_URL}/${id}`, payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Failed to update asset"
      );
    }
  }
);
